import styled from 'styled-components';

import { CommonFlex } from '../../styledComponents/common';

export const ScrollableContainer = styled.div`
  overflow-x: auto;
  overflow-y: visible;
  padding: 30px 0;
  position: relative;
  margin-top: -20px;
`;

export const VerticalScale = styled.div`
  width: 50px;
  height: 25px;
  text-align: right;
`;

export const BarContainer = styled.div`
  height: 100%;
  position: relative;
`;

export const Bar = styled.div`
  width: 20px;
  background-color: ${({ bgColor }) => bgColor};
  position: relative;
  color: transparent;
  height: ${({ height }) => height};
`;

export const TooltipWrapper = styled.div`
  position: absolute;
  left: -30px;
  width: 200px;
  height: min-content;
  z-index: 1000;
`;

export const HorizontalScale = styled.div`
  width: ${({ width }) => width};
  border-bottom: 1px dotted grey;
  color: transparent;
  text-align: left;
  height: 25px;
  overflow: visible;
`;

export const AbsoluteScaleContainer = styled(CommonFlex)`
  position: absolute;
  top: -13px;
  left: 52px;
  z-index: 1;
  padding-top: 30px;
  text-align: start;
`;

export const CenteredText = styled(CommonFlex)`
  width: 100%;
  justify-content: center;
`;
